<template>
  <div class="table">
    <div class="cell">
        <div class="gmb-loader">
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
</div>
</template>

<script>
export default {
  name: "SignInWithToken",
  components: {},
  created() {
    this.$store.dispatch("auth/signInWithToken", {
      token: this.$route.query.token,
    });
  },
};
</script>

<style lang="scss">
.gmb-loader {
  font-size: 0;
  display: inline-block;
  position: relative;
  height: 120px;
  width: 120px;
}
.gmb-loader div {
  background: #56C4B4;
  width: 30px;
  height: 30px;
  border-radius: 30px;
  position: absolute;
  -webkit-animation: gmb-bounce 1.75s infinite;
          animation: gmb-bounce 1.75s infinite;
  top: 50%;
  margin-top: -15px;
}
.gmb-loader div:nth-child(2) {
  -webkit-animation-delay: 0.25s;
          animation-delay: 0.25s;
  left: 50%;
  margin-left: -15px;
}
.gmb-loader div:nth-child(3) {
  -webkit-animation-delay: 0.5s;
          animation-delay: 0.5s;
  right: 0;
}

@-webkit-keyframes gmb-bounce {
  10% {
    -webkit-transform: translate3d(0, 30px, 0);
            transform: translate3d(0, 30px, 0);
    -webkit-animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1);
            animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1);
    height: 30px;
  }
  14% {
    height: 90px;
  }
  15% {
    height: 30px;
    -webkit-transform: translate3d(0, -60px, 0);
            transform: translate3d(0, -60px, 0);
    -webkit-animation-timing-function: cubic-bezier(0.8, 0, 0.8, 1);
            animation-timing-function: cubic-bezier(0.8, 0, 0.8, 1);
  }
  35% {
    -webkit-transform: translate3d(0, 0, 0);
            transform: translate3d(0, 0, 0);
  }
}

@keyframes gmb-bounce {
  10% {
    -webkit-transform: translate3d(0, 30px, 0);
            transform: translate3d(0, 30px, 0);
    -webkit-animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1);
            animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1);
    height: 30px;
  }
  14% {
    height: 90px;
  }
  15% {
    height: 30px;
    -webkit-transform: translate3d(0, -60px, 0);
            transform: translate3d(0, -60px, 0);
    -webkit-animation-timing-function: cubic-bezier(0.8, 0, 0.8, 1);
            animation-timing-function: cubic-bezier(0.8, 0, 0.8, 1);
  }
  35% {
    -webkit-transform: translate3d(0, 0, 0);
            transform: translate3d(0, 0, 0);
  }
}
body, html {
  height: 100%;
}

body {
  margin: 0;
  background: #ffffff;
}

.table {
  display: table;
  width: 100%;
  height: 100%;
  text-align: center;
}
.table .cell {
  display: table-cell;
  vertical-align: middle;
}

</style>
